import { Action, createReducer, on } from '@ngrx/store';
import { KeyValue } from '@angular/common';

import { StpActions } from '@app/stp/state/actions';

import { ChangeTypeEnum } from '@global/infrastructure/enums/change-type.enum';

import { KeyValueDict } from '@global/infrastructure/interfaces/key-value-dict';


export interface StpState {
  isDisplayProgressBar: boolean;
  policyChangeDate: Date;
  tempChangeDuration?: {
    startDate: Date,
    endDate: Date
  };
  policyChangeSelection: {
    changeType: string;
    options: KeyValueDict<boolean>;
  };
  banDates: KeyValue<string, string[]>[];
  isQuoted: {
    permanent?: {
      yourCar: boolean;
      yourMileage: boolean;
      yourRegistration: boolean;
      yourDrivers: boolean;
      yourAddresses: boolean;
      yourDetails: boolean;
      yourConvictions: boolean;
      addOns: boolean;
      yourVehicleUsage: boolean;
      whereIparkMyCar: boolean;
      renewalPreference: boolean;
    },
    temporary?: {
      temporaryCar: boolean;
      temporaryDriver: boolean;
    }
  };
  isQuoteRetrieved: boolean;
  isYourPostalAdressSelected: boolean;
  isYourPolicyAdressSelected: boolean;
}

export const initialState: StpState = {
  isDisplayProgressBar: false,
  policyChangeDate: null,
  tempChangeDuration: null,
  policyChangeSelection: {
    changeType: 'Permanent',
    options: null
  },
  banDates: [],
  isQuoted: null,
  isQuoteRetrieved: null,
  isYourPostalAdressSelected: null,
  isYourPolicyAdressSelected: null,
};

const stpReducer = createReducer(
  initialState,
  on(StpActions.showProgressBar, (state, {isDisplayProgressBar}) => ({...state, isDisplayProgressBar})),
  on(StpActions.updatePolicyChangeDate, (state, {policyChangeDate}) => {
    const {policyChangeSelection: {changeType}, tempChangeDuration} = state;
    return changeType === 'Permanent' ?
      {...state, policyChangeDate} :
      {...state, policyChangeDate, tempChangeDuration: {...tempChangeDuration, startDate: policyChangeDate}};
  }),
  on(StpActions.updatePolicyQuoteRetrievedStatus, (state, {isQuoteRetrieved}) => ({...state, isQuoteRetrieved})),
  on(StpActions.postalAdressStatus, (state, {isYourPostalAdressSelected}) => ({...state, isYourPostalAdressSelected})),
  on(StpActions.policyAdressStatus, (state, {isYourPolicyAdressSelected}) => ({...state, isYourPolicyAdressSelected})),
  on(StpActions.updatePolicyChangeType, (state, {changeType}) => ({
    ...state,
    policyChangeSelection: {...state.policyChangeSelection, changeType}
  })),
  on(StpActions.updatePolicyChangeOptions, (state, {options}) => ({
    ...state,
    policyChangeSelection: {...state.policyChangeSelection, options}
  })),
  // on(StpActions.updateBanDate, (state, {ban}) => ({...state, banDates: [...(state.banDates || []).filter(b => b.key !== ban.key), ban]})),
  on(StpActions.removeBanDate, (state, {driverId}) => ({
    ...state,
    banDates: [...state.banDates.filter(b => b.key !== `tempDigitalId_dlg_${driverId}`)]
  })),
  on(StpActions.updateQuotedStatus, state => {
    const {policyChangeSelection: { options, changeType }} = state;
    if (changeType.toLowerCase() === ChangeTypeEnum.Permanent) {
      const { yourCar, yourMileage, yourRegistration, yourDrivers, yourAddresses, yourDetails, addOns, yourConvictions, yourVehicleUsage, whereIparkMyCar, renewalPreference } =  options;
      return {...state, isQuoted: { permanent:  { yourCar, yourMileage, yourRegistration, yourDrivers, yourAddresses, yourDetails, yourConvictions, addOns, yourVehicleUsage, whereIparkMyCar, renewalPreference }}};
    } else if (changeType.toLowerCase() === ChangeTypeEnum.Temporary) {
      const { temporaryCar, temporaryDriver } =  options;
      return {...state, isQuoted: { temporary: { temporaryCar, temporaryDriver }}};
    }
    return state;
  }),
  on(StpActions.updateTempChangeEndDate, (state, {endDate}) => ({...state, tempChangeDuration: {...state.tempChangeDuration, endDate}}))
);

export function reducer(state: StpState | undefined, action: Action) {
  return stpReducer(state, action);
}
